const StackedCoinIcon = ({ color, height = '32px', width = '32px' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 29 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="stacked-coins"
  >
    <path
      d="M10.875 13.5938C15.8801 13.5938 19.9375 11.7679 19.9375 9.51562C19.9375 7.26334 15.8801 5.4375 10.875 5.4375C5.86992 5.4375 1.8125 7.26334 1.8125 9.51562C1.8125 11.7679 5.86992 13.5938 10.875 13.5938Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.8125 9.51562V14.0469C1.8125 16.3012 5.86797 18.125 10.875 18.125C15.882 18.125 19.9375 16.3012 19.9375 14.0469V9.51562"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.9375 10.9543C24.0723 11.3394 27.1875 12.982 27.1875 14.9531C27.1875 17.2074 23.132 19.0312 18.125 19.0312C15.9047 19.0312 13.8656 18.6687 12.291 18.0797"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.0625 18.0457V19.4844C9.0625 21.7387 13.118 23.5625 18.125 23.5625C23.132 23.5625 27.1875 21.7387 27.1875 19.4844V14.9531"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 13V17.5312"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 13V17"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 19V23"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24 18V22"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default StackedCoinIcon;
